<template>
  <div class="quick">
      <div class="quick-title">
        <Title :title="$t('pc_biz_group_quick')  /* 快速分组 */" @close="onCancel">
          <yxt-tooltip 
            class="item" 
            effect="dark" 
            :content="$t('pc_biz_group_quick_rule' /*将未分组成员按一定规则自动分组*/ )" 
            placement="right"
          >
            <img  class="quick-title__icon" src="../assets/question_cirlce.png" />
          </yxt-tooltip>
        </Title>
      </div>
      <div class="quick-content">
        <div class="quick-content-box">
          <span class="quick-content-box__tip">{{$t('pc_biz_group_quick_info',[leftMemberNum]) }}</span>
          <div>
            {{$t('pc_biz_group_quick_input_1') /* 分为 */}}
            <yxt-input-number 
              ref="groupInput"  
              v-model="groupNum" 
              :min="1" 
              :max="leftMemberNum" 
              type="number" 
              @change="onGroupChange" 
              @blur="computeMemberNum">
            </yxt-input-number>{{$t('pc_biz_group_quick_input_2') /* 组，每组约 */}}
            <yxt-input-number
              v-model="memberNum" 
              ref="memberInput"  
              type="number" 
              :min="1" 
              @change="onNumberChange" 
              @blur="computeGroupNum">
            </yxt-input-number>{{$t('pc_biz_group_quick_input_3') /* 人 */}}
          </div>
          <div class="quick-content-box-rule">
            <yxt-checkbox :value="rule === 'split'" @click.native.prevent="setRule('split')">{{$t('pc_biz_group_quick_split_dept') /* 同部门员工分开（尽可能） */}}</yxt-checkbox>
            <yxt-checkbox :value="rule === 'same'" @click.native.prevent="setRule('same')">{{$t('pc_biz_group_quick_same_dept') /* 同部门员工同组（尽可能） */}}</yxt-checkbox>
          </div>
        </div>
      </div>
      <div class="quick-footer">
          <Submit @cancel="onCancel" @submit="onSubmit"></Submit>
      </div>
  </div>
</template>

<script>
import { InputNumber, Message, Loading } from 'yxt-pc';
import Title from './title.vue';
import Submit from './main/components/submit.vue';

export default {
  components: {
    'yxt-input-number': InputNumber,
    Title,
    Submit
  },
  props: {
    memberList: {
      type: Array,
      require: true
    },
    groupList: {
      type: Array,
      require: true
    },
    back: {
      type: Boolean,
      default: false
    },
    maxMember: {
      type: Number,
      default: null
    },
    maxGroup: {
      type: Number,
      default: null
    }
  },
  computed: {
    leftMemberNum() {
      let total = this.memberList.length;
      for (let i = 0; i < this.groupList.length;i++) {
        total -= this.groupList[i].groupMemberList.length;
      }
      return total;
    }
  },
  inject: {
    quickGroup: {
      value: {
        default: []
      }
    },
    setPage: {
      default: () => {}
    },
    close: {
      default: () => {}
    }
  },
  data() {
    return {
      memberNum: 6,
      groupNum: 7,
      silent: true,
      rule: 'random' // same // split
    };
  },
  mounted() {
    console.log('maxGroup', this.maxGroup);
    (this.leftMemberNum < this.memberNum) && (this.memberNum = this.leftMemberNum);
    this.computeGroupNum();
    this.computeMemberNum();
    this.silent = false;
  },
  methods: {
    assertGroupNum() {
      let currentMaxGroup = this.leftMemberNum;
      let canUseMaxGroup = this.maxGroup ? this.maxGroup - this.groupList.length : this.leftMemberNum;

      let leftMaxGroup = this.leftMemberNum;

      if (canUseMaxGroup < this.leftMemberNum) {
        currentMaxGroup = this.maxGroup;
        leftMaxGroup = canUseMaxGroup;
      }
      if (this.groupNum && this.groupNum > leftMaxGroup) {
        (!this.silent) && Message.error(this.$t('pc_biz_group_max_group_tip', [currentMaxGroup] /* `组数超出上限：${currentMaxGroup}`*/));
        this.groupNum = leftMaxGroup;
        this.computeMemberNum();
      }
      setTimeout(() => {
        this.$refs.groupInput && this.$refs.groupInput.setCurrentValue(this.groupNum);
      }, 20);
    },
    assertMemberNum() {
      let currentMaxMember = this.leftMemberNum;
      if (this.maxMember && this.maxMember < this.leftMemberNum) {
        currentMaxMember = this.maxMember;
      }
      if (currentMaxMember && this.memberNum > currentMaxMember) {
        (!this.silent) && Message.error(this.$t('pc_biz_group_max_member_tip', [currentMaxMember] /* `小组人数超出上限：${currentMaxMember}` */));
        this.memberNum = currentMaxMember;
        this.computeGroupNum();
      }
      setTimeout(() => {
        this.$refs.memberInput && this.$refs.memberInput.setCurrentValue(this.memberNum);
      }, 20);
    },
    computeMemberNum() {
      if (~~this.groupNum) {
        this.memberNum = Math.ceil(this.leftMemberNum / this.groupNum);
        this.assertMemberNum();
        this.assertGroupNum();
      } else {
        this.computeGroupNum();
      }
    },
    computeGroupNum() {
      if (!~~this.memberNum && !~~this.groupNum) {
        throw new Error('not expectation value');
      }
      if (this.memberNum) {
        this.groupNum = Math.ceil(this.leftMemberNum / this.memberNum);
        this.assertMemberNum();
        this.assertGroupNum();
      } else {
        this.computeMemberNum();
      }
    },
    onNumberChange() {
      this.computeGroupNum();
    },
    onGroupChange() {
      this.computeMemberNum();
    },
    setRule(rule) {
      this.rule = this.rule === rule ? 'random' : rule;
    },
    onSubmit() {
      const loading = Loading.service({
        lock: true,
        spinner: 'yxt-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
        fullscreen: false,
        target: this.$el
      });
      // 快速分组计算是同步任务，会占用执行进程，阻碍loading渲染，使用settimeout,渲染loading后再计算
      // 通常js和渲染切换时间是17ms  50ms更稳定
      setTimeout(() => {
        try {
          this.quickGroup(this.groupNum, this.memberNum, this.rule);
        } catch (e) {
          throw new Error(e);
        } finally {
          loading.close();
        }
      }, 50);
    },
    onCancel() {
      if (this.back) {
        this.close();
      } else {
        this.setPage('Main');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.quick{
    width: 480px;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    user-select: none;
    -ms-user-select: none;

    &-title{
        padding: 16px 24px;
        border-bottom: 1px solid #E9E9E9 ;
        height: 56px;
        box-sizing: border-box;
        &__icon{
          width: 16px;
          height: 16px;
          margin-left: 4px;
          margin-top: -4px;
        }
    }
    &-content{
        flex-grow: 1;
        display: flex;
        height: calc(100% - 122px);
        &-box{
          padding: 20px;
          color: #595959;
          &__tip{
            color: #262626;
            margin-bottom: 12px;
            display: inline-block;
          }
          &-rule{
            display: flex;
            flex-direction: column;
            /deep/ .yxt-checkbox{
              margin-top: 32px;
            }
          }
          /deep/ .yxt-input-number{
            width: 82px;
            margin: 0 8px;
          }
        }
    }
    &-footer{
        height: 56px;
        background: #FFFFFF;
        box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.08);
        width: 100%;
        display: flex;
        align-self: center;
        justify-content: end;
        padding: 12px;
    }
}
</style>
